import { axiosInstance } from '../clients/axiosClient';
import { DIET_API_PREFIX, API_V1_PREFIX } from '../utils/constants';

import { ListDietDiaryResponse } from '../types/apiGeneratedTypes';

export const getDietDiaryList = async (
  id: string,
  offset: number = 0,
  limit: number = 10
): Promise<ListDietDiaryResponse> => {
  try {
    const { data } = await axiosInstance.get(
      `${API_V1_PREFIX}${DIET_API_PREFIX}list?member_id=${id}&limit=${limit}&offset=${offset}`
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};
